import React from 'react';

import { SVGComponentProps } from './svg.types';

const ProfileImageTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  stroke = '#4B5563',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSVGProps}
      >
        <path
          d="M12.9088 5.34615C12.9088 6.11758 12.6023 6.8574 12.0569 7.40288C11.5114 7.94836 10.7715 8.25481 10.0001 8.25481C9.2287 8.25481 8.48888 7.94836 7.9434 7.40288C7.39792 6.8574 7.09147 6.11758 7.09147 5.34615C7.09147 4.57473 7.39792 3.8349 7.9434 3.28943C8.48888 2.74395 9.2287 2.4375 10.0001 2.4375C10.7715 2.4375 11.5114 2.74395 12.0569 3.28943C12.6023 3.8349 12.9088 4.57473 12.9088 5.34615V5.34615ZM4.18359 16.2967C4.20852 14.7705 4.83229 13.3152 5.92039 12.2447C7.00849 11.1743 8.47373 10.5743 10.0001 10.5743C11.5265 10.5743 12.9918 11.1743 14.0799 12.2447C15.168 13.3152 15.7917 14.7705 15.8167 16.2967C13.9919 17.1334 12.0076 17.5652 10.0001 17.5625C7.92451 17.5625 5.95438 17.1095 4.18359 16.2967Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ProfileImageTwoSVG;
